import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getAPIClient } from "../apiClient";
import { getAuth } from "firebase/auth";
import logout from "../utils/logout";
import { fetchRecordsUntilUpdated, stopPolling } from "../utils/polling";
import { isAuth } from "../utils/auth";

interface RequiresAuthProps {
  children: JSX.Element;
}

export default function RequiresAuth({ children }: RequiresAuthProps) {
  const [isAuthed, setIsAuthed] = useState<Boolean | null>(null);
  const navigate = useNavigate();

  async function signOut() {
    stopPolling();
    await logout(getAPIClient(), getAuth());
    navigate("/");
  }

  /**
   * This side effect is responsible for the initial loading of all the user's
   * records when this component mounts - which will only happen when the user
   * logs in or refreshes the app.
   */
  useEffect(() => {
    if (isAuthed) {
      fetchRecordsUntilUpdated();
    }
  }, [isAuthed]);

  useEffect(() => {
    const checkDB = async () => {
      let authed = false;
      try {
        authed = await isAuth();
      } catch (e: unknown) {
        authed = false;
      } finally {
        setIsAuthed(authed);
        if (!authed) {
          await signOut();
        }
      }
    };

    if (isAuthed === null) {
      checkDB();
    }
  }, []);

  if (isAuthed) {
    return children;
  }
  return null;
}
